import { render, staticRenderFns } from "./reportSettings.vue?vue&type=template&id=1538291a&scoped=true"
import script from "./reportSettings.vue?vue&type=script&lang=js"
export * from "./reportSettings.vue?vue&type=script&lang=js"
import style0 from "./reportSettings.vue?vue&type=style&index=0&id=1538291a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1538291a",
  null
  
)

export default component.exports